function handleCustom() {
    var totalLineEl = document.querySelector('[bss-b2b-order-list-total-line]');
    var variant = totalLineEl ? totalLineEl.getAttribute('bss-b2b-order-list-total-line') : '';
    if (!variant) {
        var checkedVariant = document.querySelector('.product-form__input--pill input[type=radio]:checked');
        if (checkedVariant) {
            variant = checkedVariant.getAttribute('data-id');
        }
    }

    // 仅在 BSS_B2B 正常注入时才执行后续逻辑，避免 “BSS_B2B is not defined” 报错
    if (typeof BSS_B2B !== 'undefined' && BSS_B2B && BSS_B2B.storage && BSS_B2B.storage.variantStorage && variant) {
        const variantInfo = BSS_B2B.storage.variantStorage.get(Number(variant));
        if (variantInfo && variantInfo.bssB2BPriceAfterCP) {
            var qtyInput = document.querySelector('.price-per-item__container quantity-input .quantity__input');
            if (!qtyInput) return;
            let quanity = Number(qtyInput.value);
            let subprice = ((variantInfo.bssB2BPriceAfterCP * quanity) / 100).toFixed(2);
            let comparePrice = ((variantInfo.price * quanity) / 100).toFixed(2);
            let priceEle = document.querySelectorAll('[bss-b2b-order-list-total-line]');

            if (variantInfo && variantInfo.appliedCP && comparePrice) {
                priceEle.forEach((e) => {
                    e.innerHTML = ` <span bss-compare style="text-decoration: line-through; margin-right: 10px">${comparePrice} </span> <span class="money done" bss-sub-total > ${subprice}</span>`;
                });
            }
        }
    }
}



setTimeout(() => {
    let quanityInput = document.querySelector('.price-per-item__container quantity-input .quantity__input');
    if (quanityInput) {
        quanityInput.addEventListener('change', () => {
            setTimeout(() => {
                handleCustom();
            }, 1000);
        });
    }

    let label = document.querySelectorAll('.product-form__input label');
    if (label && label.length) {
        label.forEach((e) => {
            e.addEventListener('click', () => {
                setTimeout(() => {
                    handleCustom();
                }, 1000);
            });
        });
    }

    handleCustom();
}, 3000);
